<template>
  <content-container class="party-form" :loading="loading">
    <ValidationObserver ref="formObserver" slim v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="list-container">
          <div class="list-scroll">
            <div
              class="party-member"
              v-for="(p, i) in party"
              :key="`party-hard-${i}`"
            >
              <ValidationProvider
                name="Name"
                slim
                rules="required|clean|no-emoji|alpha-only"
                v-slot="{ errors }"
                :vid="`name-validation-${i}`"
              >
                <div>
                  <error-container :errors="errors" />
                  <div class="input-container">
                    <input
                      type="text"
                      class="name-input"
                      v-model="p.name"
                      v-on:keyup="onTextChanged"
                      placeholder="Name"
                      :key="`name-input-${i}`"
                    />
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider
                name="House"
                slim
                rules="required"
                v-slot="{ errors }"
                :vid="`house-validation-${i}`"
              >
                <div>
                  <error-container :errors="errors" />
                  <house-selector v-model="p.house" :key="`house-input-${i}`" />
                </div>
              </ValidationProvider>
              <separator />
            </div>
            <div class="filler" />
            <div class="button-container add-button">
              <div class="add-btn" v-on:click="addMember">Add Party Member</div>
            </div>
          </div>
        </div>
        <separator big="true" :margin="'35px'" />
        <div class="button-container vertical form-buttons">
          <router-link to="/" class="btn">
            <div>Cancel</div>
          </router-link>
          <button type="submit" class="confirm-btn btn">Submit</button>
        </div>
      </form>
    </ValidationObserver>
  </content-container>
</template>

<script>
import Axios from "axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import ContentContainer from "../../../components/content-container.vue";
import separator from "../../../components/seperator.vue";
import HouseSelector from "../../../components/house-selector.vue";
import ErrorContainer from "../../../components/error-container.vue";

export default {
  components: {
    "content-container": ContentContainer,
    separator,
    HouseSelector,
    ValidationProvider,
    ValidationObserver,
    ErrorContainer,
  },
  data: function () {
    return {
      party: [{ name: "", house: "" }],
    };
  },
  computed: {
    loading: function () {
      return this.$root.$data.state.loading;
    },
  },
  methods: {
    onSubmit() {
      const houses = ["gryffindor", "hufflepuff", "ravenclaw", "slytherin"];
      const party = this.party.map((p) => {
        if (p.house === "random") {
          p.house = houses[Math.floor(Math.random() * houses.length)];
        }
        return p;
      });

      console.log("SUBMIT PARTY");
      party.forEach((p) => {
        console.log(`${p.name} - ${p.house}`);
      });

      this.$root.$data.state.loading = true;
      const data = {
        party,
        token: this.$root.$data.state.token,
        id: this.$root.$data.state.id,
      };

      console.log(data);
      
      Axios.put("/add-party", data)
        .then((res) => {
          console.log("WE DID IT!!!");
          console.log(res);
          if (res) {
            this.$router.push("/finish");
          } else {
            this.$router.push("/");
          }
        })
        .catch((err) => {
          console.error(err);

          this.$root.$data.state.loading = false;
          if (err.response.status === 403) {
            console.log("redirecting back");
            this.$root.$data.state.error = "The page has expired.";
            this.$router.push("/");
          }
        });
    },
    addMember() {
      this.party.push({ name: "", house: "" });
    },
    onTextChanged(evt) {
      const { key, target } = evt;
      if (key === "Enter") {
        target.blur();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../styles/colours.scss";
@import "../../../styles/fontstyles.scss";

.party-form {
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    > div {
      width: 100%;
    }

    .list-container {
      position: relative;
      width: 100%;
      height: 100%;
      .list-scroll {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: hidden;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        align-items: center;

        .party-member {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          > div {
            width: 100%;
            margin-bottom: 1.5em;
            // border: 1px solid yellow;
          }
        }

        .filler {
          height: 100%;
          width: 100%;
        }
      }
    }

    .input-container {
      border: 1px solid white;
      padding: 0.5em;
      width: 100%;
      input {
        font-size: 1em;
        width: 100%;
        height: 100%;
        background-color: #c0c1c3;
        font-family: "Linotype";
        text-align: center;
        padding-top: 0.75em;
        &:focus {
          outline: none;
        }
      }
    }

    .form-buttons {
      flex-grow: 2;
      justify-content: flex-end;
      margin-bottom: 1.5em;
      .btn:not(:last-child) {
        margin-right: 1em;
      }
    }
  }
}
</style>